module.exports = __webpack_public_path__ + "static/custom-events1-2363618a26feef9f1abec016039e13c9.png";